import { FullMarketplaceItem, MarketplaceItem, conditionLabels } from 'model';
import { FormValuesType, SetValuesFunction } from '../../hooks/useFormValues.js';
import { LinkPreviewComponent } from '../LinkPreviewComponent.js';
// eslint-disable-next-line css-modules/no-unused-class
import formStyles from '../Forms/FormFields.module.css';
// eslint-disable-next-line css-modules/no-unused-class
import postStyles from '../../styles/posts.module.css';
import { TopicSearchBox } from '../Forms/TopicSearchBox.js';
import { FormInput } from '../Forms/FormInput.js';
// styles
import styles from './MarketplaceItemEditView.module.css';
import { FormInlineImageArea } from '../Forms/FormInlineImageArea.js';
import { FormTextarea } from '../Forms/FormTextarea.js';
import { UploadImageButton } from '../UploadImageButton.js';
import { FormSelectBox } from '../Forms/FormSelectBox.js';
import { BigImageContainer } from '../BigImageContainer.js';
import { filterInlineImages } from '../../util/filterInlineImages.js';
import { FormNumberInput } from '../Forms/FormNumberInput.js';
import { useImageUpload } from '../../hooks/useImageUpload.js';
import { useAddPostImageMutation } from '../../api/PostApi.js';
import { usePasteURL } from '../../hooks/usePasteURL.js';
import { IonSpinner } from '@ionic/react';
// eslint-disable-next-line css-modules/no-unused-class
import postEditStyles from '../PostEditFields.module.css';
import { IconButton } from '../IconButton.js';
import { IconCurrency } from '../QuirkIcons/index.js';
import { Price } from '../Price.js';
export interface MarketplaceItemEditViewProps {
	formValues: FormValuesType<MarketplaceItem>;
	setValues: SetValuesFunction<MarketplaceItem>;
	item: FullMarketplaceItem;
}

export function MarketplaceItemEditView({ formValues, setValues, item }: MarketplaceItemEditViewProps) {
	const { uploadImage } = useImageUpload(item, useAddPostImageMutation);
	const { onPaste: onPasteSocial, loading: loadingSocial } = usePasteURL<MarketplaceItem>(setValues, 'contents');
	const onPaste = async (e: React.ClipboardEvent<HTMLTextAreaElement>) => {
		onPasteSocial(e);
		uploadImage(e);
	};
	return (
		<div className={formStyles.fieldsContainer}>
			{formValues !== undefined && (
				<>
					<TopicSearchBox
						label="Category"
						topic={formValues.topic?.value ?? ''}
						setValues={setValues}
						errors={formValues?.topic?.errors}
					/>
					<FormInput
						id="title"
						setValues={setValues}
						field={formValues.title}
						label="Item Offered"
						testId="editPostTitleField"
					/>
					<FormSelectBox
						id="condition"
						setValues={setValues}
						field={formValues.condition}
						label="Condition"
						options={conditionLabels}
					/>
					<div className={styles.priceWrapper}>
						{formValues.price?.value !== 0 && (
							<>
								<FormNumberInput
									field={formValues.price}
									id="price"
									setValues={setValues}
									label="Price"
									placeholder="Price"
									places={0}
									testId="editPostPriceField"
									disabled={formValues.price?.value === 0}
								/>
								<div className={styles.toggleWrapper}>
									<IconButton
										onClick={() => {
											setValues({
												price: 0
											});
										}}
										outline
										iconRight
										label="Free Item"
										icon={<IconCurrency />}
									/>
								</div>
							</>
						)}
						{formValues.price?.value === 0 && (
							<>
								<div className={styles.freeWrapper}>
									<div className={formStyles.label}>Price</div>
									<Price price={formValues.price?.value ?? 0} showFree />
								</div>
								<div className={styles.toggleWrapper}>
									<IconButton
										testId="setPostPriceButton"
										outline
										iconRight
										onClick={() => {
											setValues({
												price: undefined
											});
										}}
										label="Set Price"
										icon={<IconCurrency />}
									/>
								</div>
							</>
						)}
					</div>
					<FormInlineImageArea setValues={setValues} content={formValues?.contents?.value} document={item}>
						<FormTextarea
							id="contents"
							rows={7}
							setValues={setValues}
							field={formValues.contents}
							label="Item Description"
							inlineImage
							placeholder="Type your post, paste images or links to embed them"
							testId="editPostContentField"
							onPaste={onPaste}
						/>
						{loadingSocial && (
							<div className={postEditStyles.loading}>
								<div>Fetching Preview</div>
								<IonSpinner style={{ height: '15px' }} />
							</div>
						)}
					</FormInlineImageArea>
					{item.images.length > 0 && (
						<div className={postStyles.postImageContainer}>
							<BigImageContainer
								post={item}
								edit={true}
								images={filterInlineImages(formValues?.contents?.value as string, item.images)}
							/>
						</div>
					)}
					<LinkPreviewComponent<MarketplaceItem>
						setValues={setValues}
						linkPreview={formValues?.linkPreview?.value}
					/>
					<div className={styles.postFooter}>
						{item.images.length < 6 && <UploadImageButton post={item} iconRight label="Photos" />}
					</div>
				</>
			)}
		</div>
	);
}
